import { jsx as _jsx } from "react/jsx-runtime";
import LockClosed from '../icons/lock-closed.svg';
import LockOpen from '../icons/lock-open.svg';
import styles from './styles.module.scss';
export var LockBtn = function (props) {
    return (_jsx("button", { type: "button", className: styles['icon-btn'], onClick: props.onClick, children: props.isLocked ? _jsx(LockClosed, { className: styles['icon-black'] }) : _jsx(LockOpen, { className: styles['icon-black'] }) }));
};
